import { render } from "./BackgroundColor.vue?vue&type=template&id=c3266c68&scoped=true&ts=true"
import script from "./BackgroundColor.vue?vue&type=script&lang=ts"
export * from "./BackgroundColor.vue?vue&type=script&lang=ts"

import "./BackgroundColor.vue?vue&type=style&index=0&id=c3266c68&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3266c68"]])

export default __exports__